import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ScientiaColors from "../../styles/scientia-colors.json";
import login from '../../images/login.svg';
import create_account from '../../images/create_account.svg';
import logout from '../../images/logout.svg';
import userGuide from '../../images/user-guide.svg';
import developerApi from '../../images/developer-api.svg';
import support from '../../images/support.svg';
import feedback from '../../images/feedback.svg';
import upload from '../../images/upload.svg';
import myData from '../../images/my-data.svg';
import HeaderButton from '../HeaderButton';
import './../ScientiaHeader.less';
import Cookies from 'universal-cookie';
import { Button, Dropdown, MenuProps, Modal, Space, Select } from 'antd';
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import axios from "axios";
import { REF_KEYCLOAK_AUTH_TOKEN } from 'nexus-common/src/components/access/constants';
import { jwtDecode } from 'jwt-decode';
import FileManager from './FileManager';
import { CaretDownOutlined } from '@ant-design/icons';

import { HelpIcon } from '../HelpIcon';
import { AccountCircle } from '../AccountCircle';


const cookies = new Cookies();

const buttonStyles = {
    color: ScientiaColors['scientia-blue'],
    border: 'none',
    transition: 'color 0.2s',
  };

type Props = {
    userInfo: {
       user_id: any,
       user_name: any,
    };
    logoutHandler: any;
    handleMenuToggle: () => void;
    menuPropsScienceCentral: any;
    hamburgerItemsExternal: any;
};

type DecodedToken = {
  email?: string
}

interface TopicEmailMap {
  [key: string]: string;
}

const UserHeaderInfo: React.FC<Props> = ({ userInfo, logoutHandler, menuPropsScienceCentral, hamburgerItemsExternal }) => {
    const history = useNavigate();

    const handleMenuClick: MenuProps['onClick'] = (e) => {
        console.log('click', e)
    }
    const [userEmailId, setUserEmailId] = useState('');
    const [isPNNLStaff, setIsPNNLStaff] = useState<boolean>(false);
    const [isHovered, setHovered] = useState(false);
    const [isModalOpen, setIsModalOpen]= useState(false);
    const [messageContent, setMessageContent] = useState('');
    // to hold the list of selected or droppped files
    const [files, setFiles] = useState<File[]>([]);
    const [isFeedbackTopic, setIsFeedbackTopic] = useState('Science Central');
    const [feedbackReceivedModal, setFeedbackReceivedModal] = useState(false);
    const [isFileManagerModalOpen, setisFileManagerModalOpen]= useState(false);
    const [selectedEmail, setSelectedEmail] = useState((process.env.REACT_APP_SUPPORT_EMAIL));
    const refreshUrl = sessionStorage.getItem("refreshUrl");
    const refreshUrlIsSampleS = refreshUrl?.includes(process.env.REACT_APP_METADATA as string);

    useEffect(() => {
      const token = cookies.get(REF_KEYCLOAK_AUTH_TOKEN);
        if (token) {
          try {
            const decoded:DecodedToken = jwtDecode(token);
            if(decoded && decoded.email) {
              setUserEmailId(decoded.email);
              setIsPNNLStaff(decoded.email.endsWith("@pnnl.gov") || decoded.email.endsWith("@pnl.gov"));
            }
          } catch (error) {
            console.error("Error decoding token");
          }
        } 
    }, [])


    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
        setMessageContent('');
        setFiles([]);
    }

    /**
     * Prevent default for contextmenu (right click menu)
     * @param {ClickEvent} e
     */
    const contextMenu = (e: any) => {
        e.preventDefault();
    };

    const confirmLogin = () => {
      let iframe = document.querySelector('iframe');
      const dataPortalUrl = process.env.REACT_APP_DATA;
      const refreshUrl = sessionStorage.getItem("refreshUrl");
      const currentUrl = new URL(window.location.href);
      const existingSubSrc = currentUrl.searchParams.get("subSrc");
      // Create login URL and preserve subSrc parameter if it exists
      const loginUrl = new URL(window.location.origin + '/login');
      if (existingSubSrc) {
        loginUrl.searchParams.set('subSrc', existingSubSrc);
      }
      
      if(iframe && refreshUrl?.includes(dataPortalUrl as string)) {
        iframe?.contentWindow?.postMessage({action: "persistState"}, refreshUrl);
        setTimeout(() => {
          history(loginUrl.pathname + loginUrl.search);
        }, 800);
      } else {
        history(loginUrl.pathname + loginUrl.search);
      }
    };

    const createAccountButtonStyles = {
        color: ScientiaColors["scientia-dark"],
        border: 'none',
        transition: 'color 0.2s',
      };

    const handleCreateAccount = () => {
      cookies.set('scientia_url', `${window.location.href}login`, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'});
      window.location.href = process.env.REACT_APP_CREATE_USER_URL || window.location.href
    }

    const customStyles = {
      backgroundColor: ScientiaColors['scientia-grey'],
      fontSize: '16px',      
      color: ScientiaColors['scientia-blue'],
      border: '5px',
      '&:hover':{
        backgroundColor: ScientiaColors['scientia-blue'],
      }
    }

    

    const closeFileManagerModal = () => setisFileManagerModalOpen(false);

    const handleMyDataClick = async () => {
      setisFileManagerModalOpen(true);
    }

    const items: MenuProps['items'] = [
      {
        label: (
          <div className="dropdown">
            <img src={myData} height="100%" alt="my-data" />
            <span
              onClick={handleMyDataClick}
              style={{
                marginLeft: '8px',
                color: ScientiaColors['scientia-blue'],
                fontFamily: 'Open Sans',
                fontSize: '16px',
                flex:1,
              }}
            >
              My Data
            </span>
          </div>
        ),
        key: '1',
      },
      {
        label: (
          <div className="dropdown">
            <img src={logout} height="100%" alt="logout" />
            <span
              onClick={logoutHandler}
              style={{
                marginLeft: '8px',
                color: ScientiaColors['scientia-blue'],
                fontFamily: 'Open Sans',
                fontSize: '16px',
                flex:1,
              }}
            >
              Logout
            </span>
          </div>
        ),
        key: '2',
      },
    ]

    const accountLoggedOutItems: MenuProps['items'] = [
      {
        label: (
          <div className="dropdown">
            <img src={login} height="100%" alt="scientia-login" />
            <span
              onClick={confirmLogin}
              style={{
                marginLeft: '8px',
                color: ScientiaColors['scientia-blue'],
                fontFamily: 'Open Sans',
                fontSize: '16px',
                flex:1,
              }}
            >
              Login
            </span>
          </div>
        ),
        key: '1',
      },
      {
        label: (
          <div className="dropdown">
            <img src={create_account} height="100%" alt="scientia-login" />
            <span
              onClick={handleCreateAccount}
              style={{
                marginLeft: '8px',
                color: ScientiaColors['scientia-blue'],
                fontFamily: 'Open Sans',
                fontSize: '16px',
                flex:1,
              }}
            >
              Create Account
            </span>
          </div>
        ),
        key: '2',
      },
    ];

    const helpItems: MenuProps['items'] = [
      {
        key: '1',
        label: (
            <div className="dropdown">
            <img src={userGuide} height="100%" alt="user-gide" />
            <a
             target="_blank"
             rel="noreferrer"
              style={{
                marginLeft: '8px',
                color: ScientiaColors['scientia-blue'],
                fontFamily: 'Open Sans',
                fontSize: '16px',
                flex:1,
              }}
              href={ refreshUrlIsSampleS ? process.env.REACT_APP_LIMS_USER_GUIDE : process.env.REACT_APP_USER_GUIDE }
            >
              { refreshUrlIsSampleS ? 'View Submission Guide' : 'View User Guide'}
            </a>
          </div>
        ),
      },
      {
        key: '2',
        label: (
            <div className="dropdown">
            <img src={feedback} height="100%" alt="feedback" />
            <span
              onClick={toggleModal}
              style={{
                marginLeft: '8px',
                color: ScientiaColors['scientia-blue'],
                fontFamily: 'Open Sans',
                fontSize: '16px',
                flex:1,
              }}
            >
              Send Feedback
            </span>
          </div>
        ),
      },
      {
        key: '3',
        label: (
            <div className="dropdown">
            <img src={support} height="100%" alt="report-issue" />
            <a
              style={{
                marginLeft: '8px',
                color: ScientiaColors['scientia-blue'],
                fontFamily: 'Open Sans',
                fontSize: '16px',
                flex:1,
              }}
              href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
            >
              Report an Issue
            </a>
          </div>
        ),  
      },
      {
        key: '4',
        label: (
            <div className="dropdown">
            <img src={developerApi} height="100%" alt="developer-api" />
            <a
              target='_blank'
              style={{
                marginLeft: '8px',
                color: ScientiaColors['scientia-blue'],
                fontFamily: 'Open Sans',
                fontSize: '16px',
              }}
              href={process.env.REACT_APP_DEVELOPER_API}
            > 
              Developer API
            </a>
          </div>
        ),  
      },
    ]

    const filterHelpItems = helpItems.filter((item) => item && ( item.key === "1" || item.key === "3"));
    
    const filteredAccountItems = userInfo ? items : accountLoggedOutItems;


    const submitFormButtonStyles = {
      backgroundColor: ScientiaColors['scientia-blue'],
      color: ScientiaColors["scientia-dark"],
      border: 'none',
      borderRadius: '0',
      opacity: messageContent ? 1 : 0.35,
      cursor: messageContent ? 'pointer' : 'not-allowed',
    };

    const fileInputRef = useRef<HTMLInputElement>(null);

    const validateFiles = (selectedFiles: File[]) => {
      // allowed file types for upload
      const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf', 'text/csv'];
      const validFiles: File[] = [];
      const inValidFiles: File[] = [];
      selectedFiles.forEach(file => {
        if(allowedTypes.includes(file.type)){
          validFiles.push(file);
        } else {
          inValidFiles.push(file);
        }
      })

      if(inValidFiles.length > 0){
        alert(`Invalid file types: ${inValidFiles.map(file => file.name).join(',')}` );
      }
      const totalSize = validFiles.reduce((acc, file) => acc+file.size, 0);
      const fiveMB = 5 * 1024 * 1024
      if(totalSize <= fiveMB){
        setFiles((prevFiles) => [...prevFiles, ...validFiles]);
      } else {
        alert("Total file size exceeds 5mb");
      }
    }

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
      event.preventDefault();
      const droppedFiles = Array.from(event.dataTransfer.files);
      validateFiles(droppedFiles);
    }

    const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFiles = event.target.files ? Array.from(event.target.files) : [];
      validateFiles(selectedFiles);
    }

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
      event.preventDefault();
    };

    const handleClickToBrowse = () => {
      fileInputRef.current?.click();
    };

    // remove file at the index
    const handleDelete = ( index: number) => {
      setFiles((prevFiles) => prevFiles.filter((_,i) => i !== index));
    }

    const handleSendEmail = async () => {
      const userEmail = userEmailId
      if(userEmail) {
        const formData = new FormData();
        formData.append('toEmail', selectedEmail || '');
        formData.append('userEmail', userEmail);
        formData.append('messageContent', messageContent);
        formData.append('feedBackTopic', isFeedbackTopic);
        files.forEach(file => formData.append('attachments', file));
        await axios.post(`${process.env.REACT_APP_SERVER_URL}/send-email`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        setIsModalOpen(false);
        setFeedbackReceivedModal(!feedbackReceivedModal);
      } else {
        console.error("Email not found");
      }
    }

     // send feedback button disable conditions
     const isButtonDisabled = !messageContent;

     const feedbackTopicEmailMap : TopicEmailMap = {
      "Science Central" : `${process.env.REACT_APP_SUPPORT_EMAIL}`,
      "Proposal Management" : `${process.env.REACT_APP_PM_SUPPORT_EMAIL}`,
      "Proposal Management - Portal Difficulties" : `${process.env.REACT_APP_PM_SUPPORT_EMAIL}`,
      "Proposal Management - User Program" : `${process.env.REACT_APP_PM_USER_PROGRAM_SUPPORT_EMAIL}`,
      "LIMS" : `${process.env.REACT_APP_LIMS_SUPPORT_EMAIL}`,
      "LIMS - L7" : `${process.env.REACT_APP_LIMS_SUPPORT_EMAIL}`,
      "LIMS - Metadata" : `${process.env.REACT_APP_LIMS_SUPPORT_EMAIL}`,
      "Data Portal": `${process.env.REACT_APP_DP_SUPPORT_EMAIL}`
     }

     const handleTopicChangeInFeedback = (value: string) => {
      // set the value as a part of subject line for email
      setIsFeedbackTopic(value);
      setSelectedEmail(feedbackTopicEmailMap[value]);
    };

    const combinedMenuItems: MenuProps['items'] = [
      {
        key: 'science-central-header',
        type: 'group',
        label: <span style={{ color: '#BABABA' }}>Science Central</span>,
        children: menuPropsScienceCentral.items.map((item: any, index: any) => ({
          ...item,
          key: `science-central-${index}`,
        })),
      },
      {
        key: 'external-links-header',
        type: 'group',
        label: <span style={{ color: '#BABABA' }}>External Links</span>,
        children: hamburgerItemsExternal.map((item: any, index: any) => ({
          ...item,
          key: `external-link-${index}`,
        })),
      },
      {
        key: 'help-header',
        type: 'group',
        label: <span style={{ color: '#BABABA' }}>Help</span>,
        children: (userInfo ? helpItems : filterHelpItems).map((item, index) => ({
          ...item,
          key: `help-item-${index}`,
        })),
      },
      {
        key: 'account-header',
        type: 'group',
        label: <span style={{ color: '#BABABA' }}>Account</span>,
        children: filteredAccountItems.map((item, index) => ({
          ...item,
          key: `account-item-${index}`,
        })),
      }
    ];

    const hamburgerMenuProps = {
      items: combinedMenuItems,
    };

    return (
      <>
        <Dropdown
          menu={hamburgerMenuProps}
          overlayClassName="dropdown-overlay-style"
          dropdownRender={(menu) => (
            <div>
              {React.cloneElement(menu as React.ReactElement, {
                style: customStyles
              })}
            </div>
          )}
        >
          <MenuOutlined className='hamburger-menu-items' style={{ color: ScientiaColors['scientia-blue'], fontSize: '24px' }}/>
        </Dropdown>

        {!userInfo && (
          <>
          <div className='logged-out-buttons'>
            <Dropdown
            menu={{items: filterHelpItems, onClick:handleMenuClick}}
            placement="bottomRight"
            overlayClassName='dropdown-overlay-style'
            dropdownRender={(menu) => (
                <div>
                  {React.cloneElement(menu as React.ReactElement, 
                  {
                      style: customStyles,
                  }
                )
                  }
                </div>
            )}
            >
              <span onClick={(e) => e.preventDefault()}>
                <Button
                  className="header-button"
                  style={{border: ScientiaColors["scientia-blue"], width: '100px' }}
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                  >
                    <Space>
                        <div className='user-name'>
                          <HelpIcon className="open-in-new" color={ScientiaColors['scientia-blue']}/>
                          <p>Help <CaretDownOutlined style={{ fontSize: '12px' }} /></p>
                        </div>
                    </Space>
                </Button>
              </span>
            </Dropdown>
            <HeaderButton className="button" label="Login" styles={buttonStyles} onClick={confirmLogin} onContextMenu={contextMenu} />
            <HeaderButton className="create-account-button" label="Create Account" styles={createAccountButtonStyles} onClick={handleCreateAccount} />
            </div> 
          </>
        )}

        {userInfo && (
          <>
            <Dropdown
                menu={{items: helpItems, onClick:handleMenuClick}}
                placement="bottomRight"
                overlayClassName='dropdown-overlay-style'
                dropdownRender={(menu) => (
                    <div>
                    {React.cloneElement(menu as React.ReactElement, {
                        style: customStyles,
                    })}
                    </div>
                )}
                >
                <span onClick={(e) => e.preventDefault()}>
                    <Button
                    className="button header-button"
                    style={{border: ScientiaColors["scientia-blue"], width: '100px' }}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    >
                        <Space>
                            <div className='user-name'> 
                                <HelpIcon className="open-in-new" color={ScientiaColors['scientia-blue']}/>
                                <p>Help <CaretDownOutlined style={{ fontSize: '12px' }} /></p>
                            </div>
                        </Space>
                    </Button>
                </span>
            </Dropdown>

            <Dropdown
                menu={{ items: filteredAccountItems }}
                overlayClassName='dropdown-overlay-style'
                dropdownRender={(menu) => (
                    <div>
                    {React.cloneElement(menu as React.ReactElement, {
                        style: customStyles,
                    })}
                    </div>
                )}
                >
                <span onClick={(e) => e.preventDefault()}>
                    <Button
                    className="button header-button"
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    >
                        <Space>
                            <div className='user-name'> 
                                  <AccountCircle className="open-in-new" color={ScientiaColors['scientia-blue']}/>
                                <p>{userInfo?.user_name} <CaretDownOutlined style={{ fontSize: '12px' }} /></p>
                            </div>
                        </Space>
                    </Button>
                </span>
            </Dropdown>

            {/* myData UI modal */}
            <Modal 
              open={isFileManagerModalOpen} 
              onCancel={closeFileManagerModal} 
              style={{height: '750px', display: 'flex', width: '900px', justifyContent: 'center'}}
              footer={[<Button key='cancel' style={{background: '#006BA0', color: '#FFF'}} onClick={closeFileManagerModal}>Close</Button>]}>
                <FileManager/>
            </Modal>

            <Modal
              open={isModalOpen}
              onCancel={toggleModal}
              closeIcon={<CloseOutlined style={{color: ScientiaColors['scientia-blue']}}/>}
              className='modalForm'
              footer={[
                <Button key='cancel' onClick={()=> setIsModalOpen(false)} 
                style={{backgroundColor: ScientiaColors['scientia-grey'], color: ScientiaColors['scientia-blue'], border: 'none'}}>
                  CANCEL</Button>,
                <Button onClick={handleSendEmail} style={submitFormButtonStyles} disabled={isButtonDisabled}
                > SEND FEEDBACK EMAIL</Button>
              ]}
            > 
              <div className='modal-text-style' style={{gap: '16px', display: 'flex', flexDirection: 'column', zIndex: '1000', }}>
                <h2 style={{color: 'white', fontSize: '32px', margin: '0px', padding: '0px', fontWeight: '600'}}>Send Feedback</h2>
                <span style={{display: 'inline', fontSize: '16px'}}>
                  Have ideas on how we can improve your experience?
                  We’d love to hear your feedback!
                </span>
              </div>

              <div className='content-style'>
                <span className='modal-text-style' style={{display: 'inline', fontWeight:'600', marginTop: '24px'}}>
                  Select Feedback Topic<span style={{color: '#FFA1A1'}}> *</span>
                </span>
                <Select
                  defaultValue="Science Central"
                  popupClassName='dropdown-popup'
                  className='select-feedback-dropdown'
                  style={{width: '250px'}}
                  onChange={handleTopicChangeInFeedback}
                  options={
                    [
                    {
                      label: <span className='select-option-group-text'>General</span>,
                      title: 'General',
                      options: [
                        { label: <span className='select-text-style' style={{fontSize: '16px'}}>Science Central</span>, value: 'Science Central'},
                      ],
                    },
                    {
                      label: <span className='select-option-group-text'>Modules</span>,
                      title: 'Modules',
                      options: [
                        { label: <span className='select-text-style' style={{fontSize: '16px'}}>Proposal Management</span>, value: 'Proposal Management'},
                        { label: <span className='select-text-style' style={{paddingLeft:'15px', fontSize: '16px'}}>Portal Difficulties</span>, value: 'Proposal Management - Portal Difficulties'},
                        { label: <span className='select-text-style' style={{paddingLeft:'15px', fontSize: '16px'}}>User Program Questions</span>, value: 'Proposal Management - User Program'},
                        { label: <span className='select-text-style' style={{fontSize: '16px'}}>LIMS</span>, value: 'LIMS'},
                        { label: <span className='select-text-style' style={{paddingLeft:'15px', fontSize: '16px'}}>Metadata</span>, value: 'LIMS - Metadata'},
                        ...(isPNNLStaff ? [
                          { label: <span className='select-text-style' style={{paddingLeft:'15px', fontSize: '16px'}}>L7</span>, value: 'LIMS - L7'},
                        ] : []),
                        { label: <span className='select-text-style' style={{fontSize: '16px'}}>Data Portal</span>, value: 'Data Portal'},
                      ],
                    },
                  ]}
                />
          
                <span className='modal-text-style' style={{display: 'inline', fontWeight:'600'}}>
                  Message<span style={{color: '#FFA1A1'}}> *</span>
                </span>
                <span>
                  <textarea className='text-box-style' style={{height: '83px'}} value={messageContent} onChange={(e) => setMessageContent(e.target.value)}/>
                </span>
                
                <span className='modal-text-style'>
                  <span style={{fontWeight: '600'}}>Attachments (Optional)</span>
                  <div style={{height: '8px'}}></div>
                  Any files that could help us better understand your feedback
                  <br/>
                  <span style={{color: '#FFA1A1'}}>Valid file types: png, jpg, jpeg, pdf, and csv</span> 
                  <div 
                    className='import-files'
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                  >
                    <img src={upload} alt = "logo" />
                    <p>Drag and drop files here</p>
                    <p style={{color: '#4D5567'}}>or</p>
                    <p onClick={handleClickToBrowse} style={{cursor: 'pointer', color: ScientiaColors['scientia-blue']}}> Click to browse files </p>
                    <input type='file' multiple ref={fileInputRef} onChange={handleFileSelect} className='file-input' />
                  </div>
                  <div className='file-list'>
                    {files.map((file, index) => (
                      <div key={index} className='file-item'>
                        <p>{file.name}</p>
                        <button className='delete-button' onClick={() => handleDelete(index)}>X</button>
                      </div>
                    ))}
                  </div>
                </span>
              </div>
            </Modal>

            <Modal 
              open={feedbackReceivedModal}
              className='feedbackReceivedModalStyle'
              closeIcon={<CloseOutlined style={{color: ScientiaColors['scientia-blue']}}/>}
              onCancel={() => setFeedbackReceivedModal(false)}
              footer={[
                <div className='button-feedback-received'>
                  <Button key='cancel' onClick={()=> setFeedbackReceivedModal(false)} style={submitFormButtonStyles}> 
                    OK
                  </Button>
                </div>
              ]}
            >
              <div className='feedback-received-modal'>
                <h2 className='h2'>Feedback Received</h2>
                <p className='p'>Thank you for taking the time to share your feedback with us. We appreciate your effort and will use your input to improve our services.</p>
              </div>
            </Modal>             
          </>
        )}
      </>
    );
};

export default UserHeaderInfo;